import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loadMainPermission } from '../../../../store/Actions/ActionRolesAndPermissions';

function UsePermissions() {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const permissionss = useSelector(state => state.role.mainPermission)
    const loadingMainPermission = useSelector(state => state.role.loadingMainPermission)
    useEffect(() => {
        if (permissionss?.length === 0) {
            dispatch(loadMainPermission(navigate))
        }
    }, [permissionss]);
    return { permissionss, loadingMainPermission };
}

function hasPermissions(requiredPermissions, userPermissions) {
    const userPermissionNames = userPermissions.map(permission => permission.name);
    const requiredPermissionNames = requiredPermissions.map(permission => permission.name);
    const matchingPermissions = userPermissionNames.filter(name => requiredPermissionNames.includes(name));
    return requiredPermissionNames.every(name => matchingPermissions.includes(name));
}

export { UsePermissions, hasPermissions };